import { createLightTheme } from 'baseui'

const primitives = {
    primaryFontFamily: "'Albert Sans', sans-serif",
    primary: '#000',
    primary50: '#0f0f0f',
    primary100: '#202020',
    primary200: '#313131',
    primary300: '#424242',
    primary400: '#535353',
    primary500: '#646464',
    primary600: '#757575',
    primary700: '#868686',
    accent: '#fff',
    accent50: '#f4f4f4',
    accent100: '#e3e3e3',
    accent200: '#e3e3e3',
    accent300: '#d2d2d2',
    accent400: '#c1c1c1',
    accent500: '#b0b0b0',
    accent600: '#9f9f9f',
    accent700: '#8e8e8e'
}

const overrides = {}

const theme = createLightTheme(primitives, overrides)

export default { ...theme }
